/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const view = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 4c-2.51-.042-5.103 1.711-6.734 3.506a1.035 1.035 0 0 0 0 1.385c1.595 1.758 4.182 3.55 6.733 3.508 2.551.043 5.138-1.75 6.735-3.508a1.035 1.035 0 0 0 0-1.385C13.101 5.711 10.507 3.958 8 4.001Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.75 8.2a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
    />
  </svg>
)
export default view
